import { DefaultService } from '@/services/DefaultService';

export default class ProLpsService extends DefaultService {
    constructor(http, router, env) {
        super(http, router, env);
    }

    save(lps) {
        return this._http.post(`${this._env}/promotor/lps`, lps, this._headers).then(
            (res) => {
                return res.body;
            },
            (err) => {
                this.handleError(err);
            }
        );
    }

    find(id) {
        return this._http.get(`${this._env}/promotor/lps/${id}.json`, this._headers).then(
            (res) => {
                return res.body;
            },
            (err) => {
                this.handleError(err);
            }
        );
    }

    delete(id) {
        return this._http.delete(`${this._env}/promotor/lps/${id}`, this._headers).then(
            (res) => {
                return res.body;
            },
            (err) => {
                this.handleError(err);
            }
        );
    }

    findAll(column = 'nome', order = 'asc', page = 0, limit = 50, situacao = 2, ...params) {
        return this._http
            .get(
                encodeURI(
                    `${
                        this._env
                    }/promotor/lps.json?column=${column}&order=${order}&page=${page}&limit=${limit}&situacao=${situacao}&param=${params}`
                ),
                this._headers
            )
            .then(
                (res) => {
                    return res.body;
                },
                (err) => {
                    this.handleError(err);
                }
            );
    }

    findAllList(column = 'nome', order = 'asc', page = 0, limit = 50, situacao = 2, ...params) {
        return this._http
            .get(
                encodeURI(
                    `${
                        this._env
                    }/promotor/list/lps.json?column=${column}&order=${order}&page=${page}&limit=${limit}&situacao=${situacao}&param=${params}`
                ),
                this._headers
            )
            .then(
                (res) => {
                    return res.body;
                },
                (err) => {
                    this.handleError(err);
                }
            );
    }

    findLpsForContratos(ids, ...params) {
        return this._http
            .post(
                encodeURI(`${this._env}/promotor/lpsforcontratos.json?param=${params}`),
                ids,
                this._headers
            )
            .then(
                (res) => {
                    return res.body;
                },
                (err) => {
                    this.handleError(err);
                }
            );
    }

    findAllWithContracts(page = 0, limit = 50, ids, ...params) {
        return this._http
            .post(
                `${
                    this._env
                }/promotor/lps/contracts.json?page=${page}&limit=${limit}&param=${params}`,
                ids,
                this._headers
            )
            .then(
                (res) => {
                    return res.body;
                },
                (err) => {
                    this.handleError(err);
                }
            );
    }

    findByLatLong(page = 0, limit = 50, lat, lng) {
        return this._http
            .get(
                `${
                    this._env
                }/promotor/lps/coordinates.json?page=${page}&limit=${limit}&lat=${lat}&lng=${lng}`,
                this._headers
            )
            .then(
                (res) => {
                    return res.body;
                },
                (err) => {
                    this.handleError(err);
                }
            );
    }

    getInfoByCNPJ(uf, cnpj) {
        return this._http
            .get(`${this._env}/general/cnpj.json?uf=${uf}&cnpj=${cnpj}`, this._headers)
            .then(
                (res) => {
                    return res.body;
                },
                (err) => {
                    this.handleError(err);
                }
            );
    }

    getInfoByCEP(cep, token) {
        return this._http
            .post(
                `${this._env}/consultacep/${cep}`,
                { token: token },
                { 'Content-Type': 'application/json' }
            )
            .then(
                (res) => {
                    return res.body;
                },
                (err) => {
                    this.handleError(err);
                }
            );
    }

    updateLocation(form) {
        return this._http.post(`${this._env}/pro/lps/location`, form, this._headers).then(
            (res) => {
                return res.body;
            },
            (err) => {
                this.handleError(err);
            }
        );
    }

    updateSituacao(lps) {
        return this._http.post(`${this._env}/promotor/lps/updatesituacao`, lps, this._headers).then(
            (res) => {
                return res.body;
            },
            (err) => {
                this.verifyError(err);
                throw err;
            }
        );
    }

    findAllGroupByAtendomento(filters) {
        return this._http
            .post(
                encodeURI(`${this._env}/promotor/lps/group-by-atendimento.json`),
                filters,
                this._headers
            )
            .then(
                (res) => {
                    return res.body;
                },
                (err) => {
                    this.handleError(err);
                }
            );
    }
}
